import { PureComponent, ReactNode } from 'react';
import debounce from 'lodash/debounce';

import fetchDrugSearch, { CodedMedications } from '../../../../api/fetchDrugSearch';
import { MedicationsEntity } from '../../../../store/types/prescription';
import AddDrugDialog, { AddDrugDialogProps } from './AddDrugDialog';
import { FROM_PRESCRIPTION_PAD, PAD_ADD_DRUG_DIALOG } from '../../trackSource';

type State = {
    matchingDrugs?: CodedMedications[];
};

export const ADD_DRUG = 'add-drug';

class AddDrugDialogWrapper<T extends MedicationsEntity> extends PureComponent<
    AddDrugDialogProps<T>,
    State
> {
    state: State = { matchingDrugs: [] };

    componentDidMount(): void {
        this.onChangeDebounce(this.props.drug);
    }

    onPropertyChange = async (drug: T): Promise<void> => {
        if (drug.med_cat) return;
        const res = await fetchDrugSearch(
            {
                medications: [
                    {
                        name: drug.name,
                        id: drug.id,
                        form: drug.dosage_form || drug.form,
                        unit: drug.dose?.unit,
                        uid: drug.dose?.unit,
                        generic_name: drug.generic_name,
                        generic_id: drug.generic_id,
                        manufacturer_name: drug.manufacturer_name,
                        manufacturer_id: drug.manufacturer_id,
                        frequency: drug.frequency,
                        duration: drug.duration,
                    },
                ],
            },
            FROM_PRESCRIPTION_PAD,
        );

        this.setState({ matchingDrugs: res[drug.id] });
    };

    onChangeDebounce = debounce(this.onPropertyChange, 300);

    render(): ReactNode {
        const { matchingDrugs } = this.state;

        return (
            <AddDrugDialog
                {...this.props}
                onChange={this.onPropertyChange}
                matchingDrugs={matchingDrugs}
                labelForTracking={PAD_ADD_DRUG_DIALOG}
            />
        );
    }
}

export default AddDrugDialogWrapper;
